import React from 'react';

type PropsType = {
  sizes: string[];
};

import styles from './ProductCardSizes.module.scss';

export default function ProductCardSizes({ sizes }: PropsType): JSX.Element {
  return (
    <ul className={styles.container}>
      {sizes.map(size => (
        <li key={size}>{size}</li>
      ))}
    </ul>
  );
}
